export const resumePreparation = {
  createAttempt({
    save,
    parse,
    onReady,
  }: {
    save: () => Promise<{ id: number }>;
    parse: (resumeId: number) => Promise<unknown>;
    onReady: () => void;
  }) {
    let resumeId: number | undefined;
    let completed = false;
    let inFlight: Promise<void> | null = null;

    const prepare = async () => {
      if (completed) return;
      // Preserve a confirmed upload across manual parse retries.
      // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
      if (resumeId === undefined) resumeId = (await save()).id;
      await parse(resumeId);
      completed = true;
      onReady();
    };

    return {
      hasSavedResume: () => resumeId !== undefined,
      run: () => {
        if (inFlight) return inFlight;
        inFlight = prepare().finally(() => {
          inFlight = null;
        });
        return inFlight;
      },
    };
  },
};
